import type {
  WorkoutProgressResponse,
  ExerciseProgressResponse,
  ProgramExercise,
  BatchSuccessRateEntry,
} from '../../services/types';
import type { CardioProgressSession } from '../../services/cardioSessionService';

export interface ChartDataPoint {
  workout: string;
  date: string;
  totalVolume: number;
  maxWeight: number;
  avgReps: number;
  avgRPE: number | null;
}

export interface ExerciseOption {
  id: number;
  name: string;
  muscleGroup: string;
  primaryMuscleGroup?: string | null;
  secondaryMuscleGroup?: string | null;
  tertiaryMuscleGroup?: string | null;
  parentExerciseId?: number | null;
  variationName?: string | null;
}

export interface LastExecutionRow {
  exercise: string;
  sets: number;
  maxWeight: number;
  totalReps: number;
  avgRPE: string;
}

export interface LastSessionDetail {
  date: string;
  name: string;
  exercises: Array<{
    exerciseName: string;
    sets: any[];
  }>;
}

export const DAY_NAMES: Record<number, string> = {
  1: 'Push Day',
  2: 'Pull Day',
  3: 'Legs Day',
  4: 'Full Body - Focus on Weak Points',
  5: 'Петък',
  6: 'Събота',
  7: 'Неделя',
};

export const MUSCLE_GROUPS = [
  { value: 'chest', label: 'Гръдни' },
  { value: 'back', label: 'Гръб' },
  { value: 'quadriceps', label: 'Квадрицепс' },
  { value: 'hamstrings', label: 'Задно бедро' },
  { value: 'adductors', label: 'Аддуктори' },
  { value: 'shoulders', label: 'Рамене' },
  { value: 'arms', label: 'Ръце' },
  { value: 'core', label: 'Корем' },
  { value: 'glutes', label: 'Глутеуси' },
  { value: 'calves', label: 'Икри' },
];

export const BROAD_MUSCLE_GROUPS = [
  { value: 'chest', label: 'Гръдни', groups: ['chest'], color: '#e53935' },
  { value: 'back', label: 'Гръб', groups: ['back'], color: '#1e88e5' },
  { value: 'arms,shoulders', label: 'Ръце (Ръце + Рамене)', groups: ['arms', 'shoulders'], color: '#8e24aa' },
  { value: 'quadriceps,hamstrings,adductors,glutes,calves', label: 'Крака (Квадрицепс + Задно бедро + Аддуктори + Глутеуси + Икри)', groups: ['quadriceps', 'hamstrings', 'adductors', 'glutes', 'calves'], color: '#43a047' },
  { value: 'core', label: 'Корем', groups: ['core'], color: '#00acc1' },
];

export const MUSCLE_GROUP_COLORS: Record<string, string> = {
  chest: '#e53935',
  back: '#1e88e5',
  quadriceps: '#43a047',
  hamstrings: '#2e7d32',
  adductors: '#7cb342',
  shoulders: '#fb8c00',
  arms: '#8e24aa',
  core: '#00acc1',
  glutes: '#d81b60',
  calves: '#6d4c41',
};

export type { WorkoutProgressResponse, ExerciseProgressResponse, ProgramExercise, BatchSuccessRateEntry, CardioProgressSession };
